import { crabDevice, jsonParseMultiple, XfnRequest } from '@hfzq/crab-utils';
import { getUserCode } from '@src/helper/get-user-code';
import { LocalCacheStorage, LocalStorageCache, AppCache } from '@src/helper/local-cache-storage';
import { Message } from '@src/helper/message';
import { Mutex } from '@src/helper/mutex';

/**
 * 获取用户凭证
 *
 * 半小时内如果出现多次请求token的情况则视为异常情况
 * 直接抛出异常
 *
 */

const localCacheStorage = new LocalCacheStorage<unknown>(
  crabDevice.isTZT ? new AppCache('__LC_MALL_AUTH_CACHE') : new LocalStorageCache('__LC_MALL_AUTH_CACHE')
);

export const xfnRequest = new XfnRequest({
  // eslint-disable-next-line @typescript-eslint/no-explicit-any
  beforeRequest: (config: any) => {
    if (config.autoLoading) {
      Message.addLoading();
    }
  },
  // eslint-disable-next-line @typescript-eslint/no-explicit-any
  finaly: (config: any) => {
    if (config.autoLoading) {
      Message.removeLoading();
    }
  },
});
const DEFAULT_AUTH_ERROR_MSG = '权限验证失败';
let mallLocalToken: null | string = '';

/**
 *持久化用户凭证
 *
 * @param t token
 */
async function saveToken(t: string): Promise<string> {
  mallLocalToken = t;
  await localCacheStorage.setCache(await getUserCode(), t, 30 * 60 * 1000);
  return t;
}

const getLocalTokenMutex = new Mutex();

/**
 * 获取存储在本地的请求凭证
 */
export async function getLocalToken(): Promise<string | null> {
  await getLocalTokenMutex.acquire();
  try {
    await getTokenFromHomeLocalStorage();
    // eslint-disable-next-line no-empty
  } catch (e) {}
  if (mallLocalToken) {
    getLocalTokenMutex.release();
    return mallLocalToken;
  }
  try {
    const t = await localCacheStorage.getCache<string>(await getUserCode());
    if (t) {
      mallLocalToken = t;
    }
  } finally {
    getLocalTokenMutex.release();
  }
  return mallLocalToken;
}

/**
 * 清空本地本地token
 * 强制下次请求重本地缓存中重新获取
 */
export function clearLocalVarToken() {
  mallLocalToken = null;
}

// eslint-disable-next-line require-jsdoc
class UserCodeError extends Error {}

/**
 * 获取服务端请求凭证
 * 经过中焯壳子获取
 */
export async function getServerToken(): Promise<string> {
  try {
    const userCode = await getUserCode();
    if (!userCode) {
      throw new UserCodeError();
    }
    const res = await xfnRequest.getXfnData({
      ACTION: '48999',
      METHOD: 'POST',
      PATH: '/redirect',
    });
    const { token } = jsonParseMultiple(res.DATA);
    if (!token) {
      // eslint-disable-next-line no-throw-literal
      throw {
        ERRORMESSAGE: DEFAULT_AUTH_ERROR_MSG,
      };
    }
    return await saveToken(token);
    // eslint-disable-next-line @typescript-eslint/no-explicit-any
  } catch (error: any) {
    if (error instanceof UserCodeError) {
      throw error;
    } else {
      // eslint-disable-next-line no-throw-literal
      throw {
        code: -1,
        message: error.ERRORMESSAGE || DEFAULT_AUTH_ERROR_MSG,
      };
    }
  }
}

/**
 * 从localStorege中获取理财首页保存的token
 */
async function getTokenFromHomeLocalStorage() {
  const KEY = '__LC_TOKEN_VALUE';
  const token = localStorage.getItem(KEY);
  if (token) {
    await saveToken(token);
    localStorage.removeItem(KEY);
  }
}
